import { DataBean } from "../DataBean";

export class UBLInvoice extends DataBean {
  public async getAccountantIDTypeCatalog(): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantIDTypeCatalog_Number",
      [null]
    );
  }

  public async getAccountantConceptCatalog(): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantConceptCatalog_Number",
      [null]
    );
  }

  public async getAccountantConceptCatalogForSupplierInvoice(): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantConceptCatalogForSupplierInvoice_Number",
      [null]
    );
  }

  public async getAccountantConceptCatalogForSalesInvoice(): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantConceptCatalogForSalesInvoice_Number",
      [null]
    );
  }

  public async getAccountantConceptCatalogForCashDesk(arg: null): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantConceptCatalogForCashDesk_Number",
      [arg]
    );
  }

  public async getUblInvoiceCatalog12(idAccountSupplier: number, idAccountCustomer: number, ublDocumentType: number, year: number, month: number, state: number, remissionSourceType: number, documentType: string, idDocument: number, documentDate: any, page: number, recordsPerPage: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getUblInvoiceCatalog_Number_Number_Number_Number_Number_Number_Number_String_Number_java.util.Date_Number_Number",
      [idAccountSupplier, idAccountCustomer, ublDocumentType, year, month, state, remissionSourceType, documentType, idDocument, documentDate, page, recordsPerPage]
    );
  }
  public async getUblInvoiceCatalogForReport(idAccountSupplier: number, idAccountCustomer: number, ublDocumentType: number, year: number, month: number, state: number, remissionSourceType: number, documentType: string, idDocument: number, documentDate: any, idAccountantConcept: any, page: number, recordsPerPage: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getUblInvoiceCatalog_Number_Number_Number_Number_Number_Number_Number_String_Number_java.util.Date_Number_Number_Number",
      [idAccountSupplier, idAccountCustomer, ublDocumentType, year, month, state, remissionSourceType, documentType, idDocument, documentDate, idAccountantConcept, page, recordsPerPage]
    );
  }
  public async getUBLAccountingDocumentTypes(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getUBLAccountingDocumentTypes_Number",
      [arg]
    );
  }

  public async getUblInvoiceCatalog(
    idAccountSupplier: number,
    from: any,
    upto: any,
    state: number | null
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getUblInvoiceCatalog_Number_java.util.Date_java.util.Date_Number",
      [idAccountSupplier, from, upto, state]
    );
  }

  public async fireElectronicDocument(
    idUBLInvoice: number,
    issueDate: any,
    idAccount: number,
    idUBLSoftwareDispatcher: number,
    idTaxEntityConsecutive: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.ubl.UBLTaxResponse_fireElectronicDocument_Number_java.util.Date_Number_Number_Number",
      [
        idUBLInvoice,
        issueDate,
        idAccount,
        idUBLSoftwareDispatcher,
        idTaxEntityConsecutive,
      ]
    );
  }
  public async fireElectronicDocumentNotes(
    idUBLInvoice: number,
    issueDate: any,
    idAccount: number,
    idUBLSoftwareDispatcher: number,
    idTaxEntityConsecutive: number,
    notes: any[]
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.ubl.UBLTaxResponse_fireElectronicDocument_Number_java.util.Date_Number_Number_Number_java.util.List",
      [
        idUBLInvoice,
        issueDate,
        idAccount,
        idUBLSoftwareDispatcher,
        idTaxEntityConsecutive,
        notes
      ]
    );
  }

  public async getAccountantDocumentList(
    idUBLInvoice: number,
    issueDate: any,
    idAccount: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantDocumentList_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idAccount]
    );
  }

  public async getUblDocumentInvoiceCatalog(
    idAccountSupplier: number,
    idAccountCustomer: number,
    ublDocumentType: number,
    year: number,
    month: number,
    state: number,
    page: number,
    recordsPerPage: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getUblInvoiceCatalog_Number_Number_Number_Number_Number_Number_Number_Number",
      [
        idAccountSupplier,
        idAccountCustomer,
        ublDocumentType,
        year,
        month,
        state,
        page,
        recordsPerPage,
      ]
    );
  }

  public async getDocumentStateConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getDocumentStateConstants_Number",
      [arg]
    );
  }

  public async getRemissionStateConstantsFromProductionOrder(
    arg: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getRemissionStateConstantsFromProductionOrder_Number",
      [arg]
    );
  }

  public async getRemissionStateConstantsFromStore(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getRemissionStateConstantsFromStore_Number",
      [arg]
    );
  }

  public async getRemissionTypeConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getRemissionTypeConstants_Number",
      [arg]
    );
  }

  public async getUBLDocumentTypeConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getUBLDocumentTypeConstants_Number",
      [arg]
    );
  }

  public async getUblInvoice(
    idUBLInvoice: number,
    issueDate: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_getUblInvoice_Number_java.util.Date",
      [idUBLInvoice, issueDate]
    );
  }

  public async createUBLInvoice(
    documentType: number,
    idStore: number,
    idAccountantConcept: number,
    idAccount: number,
    invoiceNumber: string,
    isDocumentSupport: boolean,
    issueDate: any,
    accountantDate: any,
    media: string,
    mediaContext: string,
    idAccountFiled: number,
    obs: string,
    idBusinessCore: number,
    idProject: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createUBLInvoice_Number_Number_Number_Number_String_Boolean_java.util.Date_java.util.Date_String_String_Number_String_Number_Number",
      [
        documentType,
        idStore,
        idAccountantConcept,
        idAccount,
        invoiceNumber,
        isDocumentSupport,
        issueDate,
        accountantDate,
        media,
        mediaContext,
        idAccountFiled,
        obs,
        idBusinessCore,
        idProject,
      ]
    );
  }

  public async getUBLEventHistoryCatalog(
    idUBLInvoice: number,
    issueDate: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getUBLEventHistoryCatalog_Number_java.util.Date",
      [idUBLInvoice, issueDate]
    );
  }

  public async createUBLInvoiceForSales(
    idAccount: number,
    idStore: number,
    idAccountantConcept: number,
    issueDate: any,
    media: string,
    mediaContext: string,
    idAccountFiled: number,
    observations: string,
    idBusinessCore: number,
    idProject: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createUBLInvoiceForSales_Number_Number_Number_java.util.Date_String_String_Number_String_Number_Number",
      [
        idAccount,
        idStore,
        idAccountantConcept,
        issueDate,
        media,
        mediaContext,
        idAccountFiled,
        observations,
        idBusinessCore,
        idProject,
      ]
    );
  }

  public async createUBLInvoiceForSales13(
    idAccount: number,
    idStore: number,
    idAccountantConcept: number,
    issueDate: any,
    media: string,
    mediaContext: string,
    idAccountFiled: number,
    observations: string,
    idBusinessCore: number,
    idProject: number,
    idPriceList: number,
    ifrIDDocument: number,
    ifrDocumentDate: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createUBLInvoiceForSales_Number_Number_Number_java.util.Date_String_String_Number_String_Number_Number_Number_Number_java.util.Date",
      [
        idAccount,
        idStore,
        idAccountantConcept,
        issueDate,
        media,
        mediaContext,
        idAccountFiled,
        observations,
        idBusinessCore,
        idProject,
        idPriceList,
        ifrIDDocument,
        ifrDocumentDate
      ]
    );
  }

  public async getInvoiceStateConstants(arg: null): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getInvoiceStateConstants_Number",
      [null]
    );
  }

  public async addUBLItemInvoiceToAdquisitionArticle(
    idSupplierPaymentOrderItem: any,
    supplierPaymentOrderDate: any,
    idUBLItemInvoice: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLItemInvoice_addUBLItemInvoiceToAdquisitionArticle_Number_java.util.Date_Number",
      [idSupplierPaymentOrderItem, supplierPaymentOrderDate, idUBLItemInvoice]
    );
  }

  public async releaseUBLItemInvoiceFromAdquisitionArticle(
    idUBLInvoice: any,
    issueDate: any,
    idAdquisitionContract: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLItemInvoice_releaseUBLItemInvoiceFromAdquisitionArticle_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idAdquisitionContract]
    );
  }

  public async importUBLInvoice(
    idConcept: number,
    media: string,
    mediaContext: string,
    dataStore: string | null,
    issueDate: Date | string,
    importProperties: any,
    idEmployee: number,
    observation: string
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_importUBLInvoice_Number_String_String_String_java.util.Date_java.util.Map_Number_String",
      [
        idConcept,
        media,
        mediaContext,
        dataStore,
        issueDate,
        importProperties,
        idEmployee,
        observation,
      ]
    );
  }

  public async importUBLInvoiceContainer(
    idAccountantConcept: number,
    media: string,
    mediaContext: string,
    dataStore: string | null,
    issueDate: Date | string,
    importProperties: any,
    idEmployee: number,
    observation: string
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_importUBLInvoice_Number_String_String_String_java.util.Date_java.util.Map_Number_String",
      [
        idAccountantConcept,
        media,
        mediaContext,
        dataStore,
        issueDate,
        importProperties,
        idEmployee,
        observation,
      ]
    );
  }

  public async getUblInvoiceCatalogForStore(
    idAccountSupplier: number | null,
    year: number,
    page: number,
    recordsPerPage: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getUblInvoiceCatalogForStore_Number_Number_Number_Number",
      [idAccountSupplier, year, page, recordsPerPage]
    );
  }

  public async postSupplierPaymentOrderToSupervisor(
    idSupplierPaymentOrder: number,
    supplierPaymentOrderDate: any,
    observations: string,
    idAccountFiled: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.supplier.SupplierPaymentOrder_postSupplierPaymentOrderToSupervisor_Number_java.util.Date_String_Number",
      [
        idSupplierPaymentOrder,
        supplierPaymentOrderDate,
        observations,
        idAccountFiled,
      ]
    );
  }

  public async requestUBLInvoiceToAccounting(
    idUBLInvoice: number,
    issueDate: any,
    idAccountFiled: number,
    observations: string
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_requestUBLInvoiceToAccounting_Number_java.util.Date_Number_String",
      [idUBLInvoice, issueDate, idAccountFiled, observations]
    );
  }

  public async createFixedAssetEntryForUBLInvoice(
    idUBLInvoice: number,
    issueDate: any,
    recordDate: any,
    idStore: number,
    idEmployee: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_createFixedAssetEntryForUBLInvoice_Number_java.util.Date_java.util.Date_Number_Number",
      [idUBLInvoice, issueDate, recordDate, idStore, idEmployee]
    );
  }

  public async createAccountantDocumentForUBLInvoice(
    idUBLInvoice: number,
    issueDate: any,
    recordDate: any,
    idEmployee: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_createAccountantDocumentForUBLInvoice_Number_java.util.Date_java.util.Date_Number",
      [idUBLInvoice, issueDate, recordDate, idEmployee]
    );
  }

  public async createPurchaseUBLInvoice(
    paymentType: number,
    accountantDate: any,
    idAccount: number,
    idThirdBankingAccount: number,
    odIDDocument: number,
    idAccountantConcept: number,
    invoiceNumber: string,
    isDocumentSupport: boolean,
    issueDate: any,
    media: string,
    mediaContext: string,
    idAccountFiled: number,
    observations: string,
    idBusinessCore: number,
    idProject: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createPurchaseUBLInvoice_Number_java.util.Date_Number_Number_Number_Number_String_Boolean_java.util.Date_String_String_Number_String_Number_Number",
      [
        paymentType,
        accountantDate,
        idAccount,
        idThirdBankingAccount,
        odIDDocument,
        idAccountantConcept,
        invoiceNumber,
        isDocumentSupport,
        issueDate,
        media,
        mediaContext,
        idAccountFiled,
        observations,
        idBusinessCore,
        idProject,
      ]
    );
  }

  public async parseTaxSchemaValuesWithHoldingTaxForUBLInvoice(
    idUBLInvoice: number,
    issueDate: any,
    taxSchemeValueList: any,
    budgetIDStr: string,
    idBudgetResource: number,
    idBudgetSource: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "double_parseTaxSchemaValuesWithHoldingTaxForUBLInvoice_Number_java.util.Date_Number_java.util.List_String_Number_Number",
      [
        idUBLInvoice,
        issueDate,
        taxSchemeValueList,
        budgetIDStr,
        idBudgetResource,
        idBudgetSource,
      ]
    );
  }

  public async updateUBLTaxWithHoldingTax(bean: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLTaxWithHoldingTax_updateUBLTaxWithHoldingTax_com.quickdataerp.bean.ubl.UBLTaxWithHoldingTax",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.quickdataerp.bean.ubl.UBLTaxWithHoldingTax",
        },
      ]
    );
  }

  public async parseTaxSchemaValuesWithHoldingTaxForUBLInvoice3(
    idUBLInvoice: number,
    issueDate: any,
    taxSchemeValueList: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "double_parseTaxSchemaValuesWithHoldingTaxForUBLInvoice_Number_java.util.Date_java.util.List",
      [idUBLInvoice, issueDate, taxSchemeValueList]
    );
  }

  public async deleteUBLTaxWithHoldingTax(
    idUBLInvoice: number,
    issueDate: any,
    idUBLTaxWithHoldingTax: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_deleteUBLTaxWithHoldingTax_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idUBLTaxWithHoldingTax]
    );
  }

  public async getUBLSoftwareDispatcherByEnvironmentType(
    arg: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLSoftwareDispatcher_getUBLSoftwareDispatcherByEnvironmentType_Number",
      [arg]
    );
  }

  public async getAvailableTaxEntityConsecutive(idUBLInvoice: number, issueDate: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAvailableTaxEntityConsecutive_Number_java.util.Date",
      [idUBLInvoice, issueDate]
    );
  }

  public async createUBLRemissionFromStore(
    idStore: number,
    idAccountantConcept: number,
    issueDate: any,
    media: string,
    mediaContext: string,
    idAccountFiled: number,
    observations: string,
    idBusinessCore: number,
    idProject: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createUBLRemissionFromStore_Number_Number_java.util.Date_String_String_Number_String_Number_Number",
      [
        idStore,
        idAccountantConcept,
        issueDate,
        media,
        mediaContext,
        idAccountFiled,
        observations,
        idBusinessCore,
        idProject,
      ]
    );
  }

  public async createUBLRemissionFromProductionOrder(
    idStore: number,
    idAccountantConcept: number,
    issueDate: any,
    media: string,
    mediaContext: string,
    idAccountFiled: number,
    observations: string,
    idBusinessCore: number,
    idProject: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createUBLRemissionFromProductionOrder_Number_Number_java.util.Date_String_String_Number_String_Number_Number",
      [
        idStore,
        idAccountantConcept,
        issueDate,
        media,
        mediaContext,
        idAccountFiled,
        observations,
        idBusinessCore,
        idProject,
      ]
    );
  }

  public async createFixedAssetEntryForRemission(
    idUBLInvoice: number,
    issueDate: any,
    recordDate: any,
    idStore: number,
    idEmployee: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_createFixedAssetEntryForRemission_Number_java.util.Date_java.util.Date_Number_Number",
      [idUBLInvoice, issueDate, recordDate, idStore, idEmployee]
    );
  }

  public async getRemissionAccountantDocument(
    idUBLInvoice: number,
    issueDate: any,
    idEmployee: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_getRemissionAccountantDocument_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idEmployee]
    );
  }

  public async getUblInvoiceCatalogProductionOrder(
    idAccountSupplier: number,
    idAccountCustomer: number,
    ublDocumentType: number,
    year: number,
    month: number,
    state: number,
    remissionSourceType: number,
    page: number,
    recordsPerPage: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getUblInvoiceCatalog_Number_Number_Number_Number_Number_Number_Number_Number_Number",
      [
        idAccountSupplier,
        idAccountCustomer,
        ublDocumentType,
        year,
        month,
        state,
        remissionSourceType,
        page,
        recordsPerPage,
      ]
    );
  }

  public async getSupplierPaymentTypeConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getSupplierPaymentTypeConstants_Number",
      [arg]
    );
  }

  public async getAccountantDocumentForInvoice(
    idUBLInvoice: number,
    issueDate: any,
    idAccount: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_getAccountantDocumentForInvoice_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idAccount]
    );
  }

  public async getFixedAssetEntryForInvoice(
    idUBLInvoice: number,
    issueDate: any,
    idAccount: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_getFixedAssetEntryForInvoice_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idAccount]
    );
  }

  public async getObligationDocumentForInvoice(
    idUBLInvoice: number,
    issueDate: any,
    idAccount: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_getObligationDocumentForInvoice_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idAccount]
    );
  }

  public async deleteTaxSchemeWithHoldingTaxForUBLInvoice(
    idUBLInvoice: number,
    issueDate: any,
    idTaxSchemeValue: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_deleteTaxSchemeWithHoldingTaxForUBLInvoice_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idTaxSchemeValue]
    );
  }

  public async nullifyUBLInvoice(
    idUBLInvoice: number,
    issueDate: any,
    idEmployee: number,
    observations: string
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_nullifyUBLInvoice_Number_java.util.Date_Number_String",
      [idUBLInvoice, issueDate, idEmployee, observations]
    );
  }

  public async updateUBLInvoice(ublInvoice: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_updateUBLInvoice_com.quickdataerp.bean.ubl.UBLInvoice",
      [
        {
          DataBeanProperties: ublInvoice,
          DataBeanName: "com.quickdataerp.bean.ubl.UBLInvoice",
        },
      ]
    );
  }

  public async getAccountantIDForReceivable(
    idAccountantIDType: number,
    jsonCode: string
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantIDForReceivable_Number_String",
      [idAccountantIDType, jsonCode]
    );
  }

  public async getAccountantIDForReceivableNull(jsonCode: null): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantIDForReceivable_String",
      [jsonCode]
    );
  }

  public async getAccountantIDForPayeable(jsonCode: null): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAccountantIDForPayeable_String",
      [jsonCode]
    );
  }

  public async getAdvancePaymentForCrossing(
    idUBLInvoice: number,
    issueDate: any,
    year: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAdvancePaymentForCrossing_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, year]
    );
  }

  public async applyPrepaidPayment(
    idUBLInvoice: number,
    issueDate: any,
    applyPrepaidValue: boolean,
    prepaidIDAccountantStr: string,
    prepaidPayment: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_applyPrepaidPayment_Number_java.util.Date_Boolean_String_Number",
      [
        idUBLInvoice,
        issueDate,
        applyPrepaidValue,
        prepaidIDAccountantStr,
        prepaidPayment,
      ]
    );
  }

  public async createUBLInvoiceForCreditNote(
    idAccount: number,
    idStore: number,
    idAccountantConcept: number,
    issueDate: any,
    media: string,
    mediaContext: string,
    idAccountFiled: number,
    observations: string,
    idBusinessCore: number,
    idProject: number,
    idUBLInvoiceOwner: number,
    issueDateOwner: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createUBLInvoiceForCreditNote_Number_Number_Number_java.util.Date_String_String_Number_String_Number_Number_Number_java.util.Date",
      [
        idAccount,
        idStore,
        idAccountantConcept,
        issueDate,
        media,
        mediaContext,
        idAccountFiled,
        observations,
        idBusinessCore,
        idProject,
        idUBLInvoiceOwner,
        issueDateOwner,
      ]
    );
  }

  public async createUBLInvoiceForDebtNote(
    idAccount: number,
    idStore: number,
    idAccountantConcept: number,
    issueDate: any,
    media: string,
    mediaContext: string,
    idAccountFiled: number,
    observations: string,
    idBusinessCore: number,
    idProject: number,
    idUBLInvoiceOwner: number,
    issueDateOwner: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createUBLInvoiceForDebtNote_Number_Number_Number_java.util.Date_String_String_Number_String_Number_Number_Number_java.util.Date",
      [
        idAccount,
        idStore,
        idAccountantConcept,
        issueDate,
        media,
        mediaContext,
        idAccountFiled,
        observations,
        idBusinessCore,
        idProject,
        idUBLInvoiceOwner,
        issueDateOwner,
      ]
    );
  }

  public async setDescriptionToUBLInvoice(
    idUBLInvoice: number,
    issueDate: any,
    description: string
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_setDescriptionToUBLInvoice_Number_java.util.Date_String",
      [idUBLInvoice, issueDate, description]
    );
  }

  public async setAccountantConceptToUBLInvoice(
    idUBLInvoice: number,
    issueDate: any,
    idAccountantConcept: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_setAccountantConceptToUBLInvoice_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idAccountantConcept]
    );
  }

  public async notifyInvoiceEmail(idEmployee: number, idUBLInvoice: number, issueDate: any, options: Record<string, any>): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.Map_notifyInvoiceEmail_Number_Number_java.util.Date_java.util.Map",
      [idEmployee, idUBLInvoice, issueDate, options]
    );
  }

  public async notifyInvoiceSIIFByEmail(idEmployee: number, idUBLInvoice: number, issueDate: any, options: Record<string, any>): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.Map_notifyInvoiceSIIFByEmail_Number_Number_java.util.Date_java.util.Map",
      [idEmployee, idUBLInvoice, issueDate, options]
    );
  }

  public async getUBLDocumentPaymentTypeConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getUBLDocumentPaymentTypeConstants_Number",
      [arg]
    );
  }

  public async getUblInvoiceAdjustmentList(idUBLInvoice: number, issueDate: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getUblInvoiceAdjustmentList_Number_java.util.Date",
      [idUBLInvoice, issueDate]
    );
  }

  public async createUBLInvoiceForCreditNoteFromUBLInvoice(newDate: any, idUBLInvoice: number, issueDate: any, observations: string, idAccountFilled: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createUBLInvoiceForCreditNoteFromUBLInvoice_java.util.Date_Number_java.util.Date_String_Number",
      [newDate, idUBLInvoice, issueDate, observations, idAccountFilled]
    );
  }

  public async createUBLInvoiceForDebitNoteFromUBLInvoice(newDate: any, idUBLInvoice: number, issueDate: any, observations: string, idAccountFilled: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_createUBLInvoiceForDebitNoteFromUBLInvoice_java.util.Date_Number_java.util.Date_String_Number",
      [newDate, idUBLInvoice, issueDate, observations, idAccountFilled]
    );
  }

  public async duplicateUBLInvoice(newDate: any, idUBLInvoice: number, issueDate: any, observations: string, idAccountFilled: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_duplicateUBLInvoice_java.util.Date_Number_java.util.Date_String_Number",
      [newDate, idUBLInvoice, issueDate, observations, idAccountFilled]
    );
  }

  public async setUBLInvoiceAsContingency(idUBLInvoice: number, issueDate: any, docDate: string, reference: string, idAccountFiled: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_setUBLInvoiceAsContingency_Number_java.util.Date_java.util.Date_String_Number",
      [idUBLInvoice, issueDate, docDate, reference, idAccountFiled]
    );
  }

  public async setUBLInvoiceContingencyAsSalesInvoice(idUBLInvoice: number, issueDate: any, idAccountFiled: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_setUBLInvoiceContingencyAsSalesInvoice_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, idAccountFiled]
    );
  }

  public async getUBLInvoiceXml(idUBLInvoice: number, issueDate: any, idAccount: number, idUBLSoftwareDispatcher: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getUBLInvoiceXml_Number_java.util.Date_Number_Number",
      [idUBLInvoice, issueDate, idAccount, idUBLSoftwareDispatcher]
    );
  }

  public async getUBLInvoiceOwner(idUBLInvoice: number, issueDate: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_getUBLInvoiceOwner_Number_java.util.Date",
      [idUBLInvoice, issueDate]
    );
  }

  public async setUBLAdminFeeTypeToUBLInvoice(idUBLInvoice: number, issueDate: any, ublAdminFeeType: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_setUBLAdminFeeTypeToUBLInvoice_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, ublAdminFeeType]
    );
  }

  public async distributeAdminFeeValue(idUBLInvoice: number, issueDate: any, ublAdminFeeType: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "boolean_distributeAdminFeeValue_Number_java.util.Date_Number",
      [idUBLInvoice, issueDate, ublAdminFeeType]
    );
  }

  public async setUBLDiscrepancyResponse(idUBLInvoice: number, issueDate: any, idUBLDiscrepancyResponse: number, description: string): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.ubl.UBLInvoice_setUBLDiscrepancyResponse_Number_java.util.Date_Number_String",
      [idUBLInvoice, issueDate, idUBLDiscrepancyResponse, description]
    );
  }

  public async getElectronicDocumentProforma(idUBLInvoice: any, issueDate: any, idAccount: any, idUBLSoftwareDispatcher: any): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getElectronicDocumentProforma_Number_java.util.Date_Number_Number", [idUBLInvoice, issueDate, idAccount, idUBLSoftwareDispatcher]);
  }

  public async getUblInvoiceCatalogBySalesOrder(idSalesOrder: number, salesOrderDate: string, state: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "java.util.List_getUblInvoiceCatalogBySalesOrder_Number_java.util.Date_Number", [idSalesOrder, salesOrderDate, state]);
  }

  public async createSalesOrderUBLInvoice(idSalesOrder: number, salesOrderDate: string, idAccountFiled: number, observations: string, idBusinessCore: number, idProject: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLInvoice_createSalesOrderUBLInvoice_Number_java.util.Date_Number_String_Number_Number", [idSalesOrder, salesOrderDate, idAccountFiled, observations, idBusinessCore, idProject]);
  }

  public async eventsInvoiceEmail(page: number, rows: number, props: Record<string, any>): Promise<any> {
    return this.getCustomService("CacheOptions", "com.advantage.shared.Report_eventsInvoiceEmail_Number_Number_java.util.Map", [page, rows, props]);
  }

}
